







































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex"
import { Route } from "vue-router";

@Component
export default class AddRemark extends Vue {
    @Prop({ type: String })
    title!: string;

    @Prop({ type: Object })
    reData!: AccountBookList.AccountRemark;

    newRemark: string = "";
    type: number = 0;
    id: number | null = null;
    date: number | null = null;

    mounted() {
        this.initData(this.reData);
    }

    // 监听备注
    @Watch("reData")
    reDataChange(val: AccountBookList.AccountRemark) {
        this.initData(val);
    }

    initData(val: AccountBookList.AccountRemark) {
        if (val != null) {
            this.newRemark = val.content;
            this.type = val.type;
            this.id = val.id;
            this.date = val.writtenDate;
        } else {
            this.clear();
        }
    }

    clear() {
        this.newRemark = "";
        this.id = null;
        this.type = 1;
        this.date = null;
    }
    confirm(e: any) {
        if (this.id == null) {
            Vue.axios
                .post(
                    `accountbookremark/create`, {
                        accountBookId: this.$store.state.accountBook.id,
                        type: this.type,
                        content: this.newRemark,
                        writtenPerson: this.$store.state.account.name,
                        writtenPersonNo: this.$store.state.account.no
                    })
                .then(res => {
                    this.$utils.getRemarks();
                });
        } else {
            Vue.axios
                .post(
                    `accountbookremark/modify`, {
                        accountBookId: this.$store.state.accountBook.id,
                        type: this.type,
                        content: this.newRemark,
                        writtenPerson: this.$store.state.account.name,
                        writtenPersonNo: this.$store.state.account.no,
                        id: this.id,
                        writtenDate: this.date
                    })
                .then(res => {
                    this.$utils.getRemarks();
                });
        }
        this.clear();
        this.$emit("close");
    }

}
